import {Injectable} from '@angular/core';
import {BaseDialogService} from "./base-dialog.service";
import {NAVIGATE_OUT_OF_CAD_DESIGNER_CONFIRMATION_MESSAGE} from "../helpers/Const";

@Injectable({
    providedIn: 'root'
})
export class ConfirmationDialogService extends BaseDialogService{
    public confirmationMessage: string = '';
    public dialogHeader: string = '';
    public onYes: (() => void) | null = null;
    setConfirmationMessage(message: string = '') {
        this.confirmationMessage = message;
    }
    setDialogHeader(header: string = '') {
        this.dialogHeader = header;
    }

    setOnYes(callback: (() => void) | null) {
        this.onYes = callback;
    }
    callOnYes() {
        if (this.onYes) {
            this.onYes();
        }
        this.close();
    }

    openLeaveCADConfirmation(onConfirm: () => void): void {
        this.setConfirmationMessage(NAVIGATE_OUT_OF_CAD_DESIGNER_CONFIRMATION_MESSAGE);
        this.setDialogHeader("Leave Cloud Automation Designer");
        this.open();
        this.setOnYes(onConfirm);
    }
}